import * as React from 'react';
export const mountainamericaSvg = React.forwardRef(
  function mountainamericaSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#CC2B46',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'M15.93 22.49H3.46s2.27-4.58 5.3-8.4c3.02-3.81 6.17-4.58 7.3-4.58 1.12 0 5.87.62 5.87 1.61 0 .99-4 .62-4 .62l2 1.23s.75-1.23 3.37-1.1c2.63.11 4.38 1.47 4.38 3.57 0 2.1-1 3.71-1 3.71s-.63-2.72-3.88-2.72c-4.62 0-6.87 6.06-6.87 6.06z',
        }),
      ),
    );
  },
);
mountainamericaSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var mountainamerica = {
  category: 'brand',
  colorable: false,
  name: 'mountainamerica',
  svg: mountainamericaSvg,
};
